module.exports = __webpack_public_path__ + "static/15-97a9f19e94b64eabd2016e1fa1f56d59.jpeg";